var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00244141H513V341.99H0V-0.00244141Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 154.957H513V187.019H0V154.957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.143 256.49L155.982 265.503L166.186 284.061L145.378 280.08L142.742 301.099L128.25 285.64L113.757 301.099L111.121 280.08L90.3139 284.061L100.517 265.503L81.3564 256.49L100.518 247.477L90.3139 228.921L111.12 232.9L113.758 211.881L128.25 227.34L142.743 211.881L145.378 232.9L166.186 228.921L155.983 247.478L175.143 256.49Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00634766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNr);
export default __webpack_public_path__ + "static/media/NR.05ce9e0837bcfa871789e0f778474be1.svg";
export { ForwardRef as ReactComponent };